<template>
  <!-- <PriorityData></PriorityData>     -->
  <TeamMemberData></TeamMemberData>
  <Projects></Projects>
</template>
<script>
import Projects from "../components/Projects/index.vue";
// import PriorityData from '../components/Priority/PriorityData.vue'
import TeamMemberData from "../components/TeamMember/TeamMemberData.vue";
import $ from "jquery";
export default {
  name: "ProjectsPage",
  components: {
    Projects,
    // PriorityData,
    TeamMemberData,
  },
  async mounted() {
    // const bHeight = $("body").height();
    // $(".firstHeightCls").height(bHeight - 23);
    $("#content").addClass("firstHeightCls");
    if (window.innerWidth < 1025) {
      $(".firstHeightCls").height(window.innerHeight);
    } else {
      const bHeight = $("body").height();
      $(".firstHeightCls").height(bHeight - 30);
    }
    this.$store.state.pageTitle = "Projects";
    this.$store.state.isLogin = 1;
    this.$store.state.NotifiCheckVal = Math.ceil(Math.random() * 1000000);
    if ($(".sectionbody").hasClass("showMobileMenu")) {
      $(".sectionbody").removeClass("showMobileMenu");
    }
  },
};
</script>
